/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   MJJ
 * @author    John Leskas <john.leskas@gmail.com>
 * @copyright 2022 John Leskas
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://mjj.com
 */

import {initializeFadeIn} from './modules/fade-in';
import {banner} from './modules/banner';
import {mobileMenu} from './modules/mobile-menu';
import {stickyHeader} from './modules/sticky-header';
import {stickyElements} from './modules/sticky-elements';
import {modal} from './modules/modal';
import {search} from './modules/search';
import {viewportWidth} from './modules/helpers';

/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0mo
 * @access public
 * @return void
 */
(function() {

	/**
	 *
	 * Modal functionality
	 *
	 */
	modal();

	/**
	 *
	 * Banner functionality
	 *
	 */
	banner();

	/**
	 *
	 * Mobile Menu functionality
	 *
	 */
	if(1024 > viewportWidth) {
		mobileMenu();
	}

	/**
	 *
	 * Search functionality
	 *
	 */
	search();

	/**
	 *
	 * Sticky header functionality
	 *
	 */
	stickyHeader();

	/**
	 * Sticky Elements
	 */
	stickyElements();

	/**
	 *
	 * Fade-in functionality
	 *
	 */
	initializeFadeIn();
})();
